// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1syQZ","item":"PaymentsMobile_item__2dCzN","label":"PaymentsMobile_label__K55az","amount":"PaymentsMobile_amount__3pnGS"};